import { logToSentry } from "utils/logger";

type TerminationParams = {
	reason: "complete" | "error";
	shouldSkip: boolean;
	fridgeId: string;
	setIsSubscriptionBroken: (broken: boolean) => void;
};

/**
 * A live subscription should never complete/error on its own while we still want it. If it does while
 * not skipped, mark the stream broken so the existing reconnect (restart+refetch) runs. A skipped
 * subscription terminating is an intentional teardown → ignore. Belt-and-suspenders to RetryLink: it
 * covers the observable closing with no error the retry path acts on.
 */
export const handleSubscriptionTermination = ({
	reason,
	shouldSkip,
	fridgeId,
	setIsSubscriptionBroken,
}: TerminationParams): void => {
	if (shouldSkip) {
		return;
	}
	logToSentry(`Subscription ${reason} while active, fridge: ${fridgeId}`, "warning");
	setIsSubscriptionBroken(true);
};
